module.exports = __webpack_public_path__ + "static/img/9.75465ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/9.png
// module id = BMAd
// module chunks = 0